module.exports = __webpack_public_path__ + "static/media/见微1218-彩钢公寓开门方向.f269cf5e.pdf";